import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export interface PublicWaiverTenant {
  id: string;
  name: string;
  slug: string;
  branding?: {
    logoUrl?: string;
    primaryColor?: string;
    secondaryColor?: string;
  } | null;
}

export interface PublicWaiverTemplate {
  id: string;
  version: number;
  title: string;
  originalFileName: string;
  uploadedAt: string | null;
}

export interface ExistingWaiverSignature {
  signedAt: string | null;
  signatureId: string;
  templateId: string;
  signerFirstName?: string | null;
  signerLastName?: string | null;
  signerEmail?: string | null;
}

export interface PublicWaiverResponse {
  tenant: PublicWaiverTenant;
  template: PublicWaiverTemplate;
  pdfUrl: string;
  existingSignature: ExistingWaiverSignature | null;
}

export interface SubmitPublicWaiverInput {
  tenantSlug: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  typedSignature: string;
  accepted: true;
}

export interface SubmitPublicWaiverResponse {
  alreadySigned: boolean;
  signatureId: string;
  signedAt: string | null;
  memberId?: string | null;
  leadId?: string | null;
}

export async function getPublicWaiver(tenantSlug: string, email?: string) {
  const fn = httpsCallable(functions, 'getPublicWaiver');
  const result = await fn({ tenantSlug, ...(email ? { email } : {}) });
  return result.data as PublicWaiverResponse;
}

export async function submitPublicWaiver(input: SubmitPublicWaiverInput) {
  const fn = httpsCallable(functions, 'submitPublicWaiver');
  const result = await fn(input);
  return result.data as SubmitPublicWaiverResponse;
}
